import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRODUCT } from '../data/content';
export function GuaranteeSection() {
  return <section className="py-10 sm:py-12" style={{
    paddingTop: "4px",
    paddingBottom: "6px"
  }} data-id="element-98" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-content px-5" data-id="element-99" data-mp="9srwbg02a049">
        <div className="mx-auto flex max-w-3xl flex-col items-start gap-4 rounded-3xl border border-lime-700/50 bg-ink-850 p-6 sm:flex-row sm:p-8" data-id="element-100" data-mp="et67h6wylq6i">
          <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-lime-600/15" aria-hidden="true" data-id="element-101" data-mp="js0vqodp46y0">
            <ShieldCheckIcon className="h-7 w-7 text-lime-400" data-id="element-102" data-mp="ns1aka4pik5l" />
          </span>
          <div data-id="element-103" data-mp="sldw2be3aau4">
            <h2 className="text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-104" data-mp="smxdw6fe8ty0">
              7-day guarantee — zero risk
            </h2>
            <p className="mt-2.5 text-sm leading-relaxed text-white/70" data-id="element-105" data-mp="12k35dfrx6myr">
              Try the techniques tonight. If within 7 days it is not what you expected — write to{' '}
              <a href={`mailto:${PRODUCT.email}`} className="font-semibold text-lime-400 underline decoration-lime-700 underline-offset-4" data-id="element-106" data-mp="25sggvb5nq1za">
                {PRODUCT.email}
              </a>{' '}
              and we refund every cent. No questions. No forms.
            </p>
            <p className="mt-2.5 text-sm font-bold text-lime-400" data-id="element-107" data-mp="1vvkeln6cqc36">Return rate: less than 1%.</p>
          </div>
        </div>
      </div>
    </section>;
}